import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,VALID_PHONE_PATTERN,PHONE_LENGTH } from './../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as trans from '../FrontMessages';
import { ROUTE_SIGN_IN,ROUTE_PHONE_OTP,RouteChanged } from '../RouteConstents';
import ShowError from "./ShowError";

const UserSignup = () => {

    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors }, setError } = useForm();
    const [phone, setPhone] = useState('');
    
    useEffect(
        () => {
        document.body.classList.add('login-page');
    }); 

    const onPhoneValidate = (value) => {
        
        if(value.length > 0 && value.length !== PHONE_LENGTH) {
            setError('phone', {
                type: "custom",
                message: trans.PLEASE_ENTER_VALID_PHONE
            })
            return true;    
        }
        return false;
    }
 
    const onSubmit = async (data) => {

        let phoneValidate = onPhoneValidate(data.phone);

        if(phoneValidate === true) {
            return false;
        }
        
        let objValue =  {"method_name":"signUpUser","phone":data.phone}
        await axios.post(API_URL,objValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status === "success") {
                    toast.success(response.data.message); 

                    navigate(RouteChanged(ROUTE_PHONE_OTP,response.data.phone_id));
                    
                } else {
                   toast.error(response.data.message); 
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
        });
        
    }

    return (
        <div style={{ backgroundColor: '#00BCD4' }}>
            
            <div className="login-box">
                <div className="logo">
                    <img src="./assets/images/logo.png" alt="SBS" width="100" />
                </div>
                <div className="card ">
                    <div className="body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <br/>
                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="tel" 
                                        className="form-control" 
                                        name="phone"
                                        maxLength="10" 
                                        placeholder="Phone" 
                                        onChange={(e) => setPhone(e.target.value)}
                                        {...register("phone",{ 
                                            required: trans.PLEASE_ENTER_PHONE,
                                            pattern: {
                                                value: VALID_PHONE_PATTERN,
                                                message: trans.PLEASE_ENTER_VALID_PHONE
                                            },
                                        } ) }
                                    />
                                </div>
                                <ShowError errorsModal={errors.phone} /> 
                            </div>
                            <div className="row">
                                <div className="col-xs-12 text-center">
                                    <button className="btn bg-pink waves-effect" type="submit">Send OTP</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="footer_login">
                <p><Link to={ROUTE_SIGN_IN}>Sign In</Link></p>
            </div>
        </div>
    );
   
}
    
export default UserSignup;